import PianoKeyboard from './PianoKeyboard'
import { MidiRouter } from './MidiRouter'
import { MidiMonitor } from './MidiMonitor'

export default function MidiPanel({ onClose }: { onClose: () => void }) {
  return (
    <div className="absolute top-4 right-4 w-[32rem] max-h-[85vh] bg-surface-base rounded-xl shadow-high border border-brd-subtle overflow-hidden z-50 flex flex-col">
      <div className="px-4 py-3 bg-second text-[color:var(--accent-ink)] flex items-center justify-between">
        <h3 className="font-bold text-sm">MIDI Router</h3>
        <button
          onClick={onClose}
          className="opacity-80 hover:opacity-100 text-lg leading-none"
        >
          x
        </button>
      </div>

      <div className="flex-1 overflow-y-auto p-4 flex flex-col gap-4">
        <MidiRouter variant="modal" />

        <section className="bg-surface-raised border border-brd-subtle rounded-xl p-3">
          <h3 className="text-[11px] font-semibold uppercase tracking-wider text-content-tertiary mb-2">
            Virtual Keyboard
          </h3>
          <div className="overflow-x-auto pb-1">
            <PianoKeyboard startOctave={3} octaves={2} />
          </div>
          <p className="text-[10px] text-content-tertiary mt-1.5">
            Use A-K keys (W/E/T/Y/U for sharps) or click/tap. Route the
            &quot;Virtual Keyboard&quot; input above to a hardware output to
            play synths from the browser.
          </p>
        </section>

        <MidiMonitor variant="modal" />
      </div>
    </div>
  )
}
